<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p><em>Gone but Not Forgotten</em> is dedicated to my beautiful wife and best friend in Heaven, June Battista Williams, who brought me to Newport, Rhode Island for the first time on the occasion of our tenth wedding anniversary. This visit, along with visits to Europe, inspired the writing of the trilogy. June’s insight, savoir-faire, and genuine appreciation of the beauty and colors of life had served to paint the backdrops of the novel along with its keen descriptions of finesse and pageantry. Her unflagging support and suggestions were monumental tools for the completion of this work.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?7c6e128a